module.exports = function _isTransformer(obj) {
  return typeof obj['@@transducer/step'] === 'function';
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/ramdasauce/~/ramda/src/internal/_isTransformer.js
 ** module id = 141
 ** module chunks = 0
 **/